import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { DBPriceSchema, PriceSchema } from './schemas';

export const PriceCodecConfig: TransformerConfig<typeof PriceSchema, typeof DBPriceSchema> = {
  name: 'Price',
  clientSchema: PriceSchema,
  dbSchema: DBPriceSchema,
  transformers: [],
};

export const encodePriceToDb = createEncodeToDbFn(PriceCodecConfig);
export const decodePriceFromDb = createDecodeFromDbFn(PriceCodecConfig);
